import {ChangeRequestComment} from 'src/openapi/models/ChangeRequestComment';

import {formatDate} from '@pb/kit-formatters';

export const formatCommentsDates = (
    comments: ChangeRequestComment[],
): ChangeRequestComment[] => {
    return comments.map(comment => ({
        ...comment,
        creationDate: `${formatDate(new Date(comment?.creationDate ?? ''), 'DD-MMM-YYYY HH:mm')}`,
    }));
};
